import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import WhatAnchorIs from './components/sections/WhatAnchorIs';
import Suites from './components/sections/Suites';
import SharedSpaces from './components/sections/SharedSpaces';
import Location from './components/sections/Location';
import Membership from './components/sections/Membership';
import './App.css';

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <WhatAnchorIs />
        <Suites />
        <SharedSpaces />
        <Location />
        <Membership />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
